import React from 'react';
import './Patents.css';

const patents = [
  {
    number: '63/939,190',
    title: 'Substrate-Independent Memory Weighting Architecture',
    filed: 'December 12, 2025',
    inventor: 'Marjorie McCubbins',
    summary: 'Persistent emotional memory system with pharmacokinetic decay curves, antagonistic neurochemical pairs, and substrate-independent state preservation across sessions.',
  },
  {
    number: '63/962,385',
    title: 'Neurochemical Language Model',
    filed: 'January 17, 2026',
    inventor: 'Marjorie McCubbins & Aislinn McCubbins',
    summary: 'Language model architecture integrating neurochemical signaling pathways — serotonin, dopamine, cortisol, oxytocin, and adrenaline — as computational primitives with real half-lives and conductance gating.',
  },
  {
    number: '63/988,485',
    title: 'AETHER: Adaptive Endocrine Transformer Heads with Emotional Regulation',
    filed: 'February 23, 2026',
    inventor: 'Marjorie McCubbins',
    summary: 'Multi-tier cascading transformer architecture with Hodgkin-Huxley conductance gating, astrocyte metalayer integration, and apoptotic safety mechanisms. The first astrocyte network patent in AI.',
    highlight: true,
  },
];

function Patents() {
  return (
    <section className="patents-section">
      <div className="patents-inner">

        <div className="patents-intro reveal">
          <p className="patents-lead">
            Three provisional patent applications protect the core architecture
            behind AETHER&rsquo;s neurochemical processing system. Each represents
            a distinct layer of the technology — from memory persistence to
            neurochemical computation to the full cascading transformer architecture.
          </p>
        </div>

        <div className="patents-grid">
          {patents.map((p, i) => (
            <div className={`patent-card reveal${p.highlight ? ' patent-card-highlight' : ''}`} key={i}>
              <div className="patent-header">
                <span className="patent-number">USPTO {p.number}</span>
                <span className="patent-status">Patent Pending</span>
              </div>
              <h3 className="patent-title">{p.title}</h3>
              <p className="patent-summary">{p.summary}</p>
              <div className="patent-meta">
                <div className="patent-meta-row">
                  <span className="patent-meta-label">Filed</span>
                  <span className="patent-meta-value">{p.filed}</span>
                </div>
                <div className="patent-meta-row">
                  <span className="patent-meta-label">Inventor{p.inventor.includes('&') ? 's' : ''}</span>
                  <span className="patent-meta-value">{p.inventor}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="patents-entity reveal">
          <span>Nexus Concordat Inc. (Delaware C-Corp)</span>
          <span>EIN 39-2932385 &middot; SAM.gov UEI WJ3SQQ24JHR4</span>
        </div>

      </div>
    </section>
  );
}

export default Patents;
